module.exports = __webpack_public_path__ + "static/media/involved-workl.2e247451.svg";